import React, { useRef, useState } from "react";
import SwipeableBottomSheet from "react-swipeable-bottom-sheet";
import BottomSheetHandle from "./BottomSheetHandle";
import Box from "@material-ui/core/Box";
import onClickOutside from "@rooks/use-outside-click";
import FocusWithin from "react-simple-focus-within"

export default function BottomSheet({
  zIndex = 9,
  visible,
  children,
  overflowHeight,
  onOpen,
  ...props
}) {
  const [open, setOpen] = useState(false);
  const divRef = useRef();
  onClickOutside(divRef, () => setOpen(false));

  const style = {
    zIndex,
    transition: "all 250ms cubic-bezier(0.86, 0, 0.07, 1)",
    transform: visible ? "translateY(0)" : `translateY(${overflowHeight}px)`
  };

  return (
    <SwipeableBottomSheet
      open={open}
      onChange={isOpen => {
        setOpen(isOpen);
        isOpen && onOpen && onOpen();
      }}
      topShadow={visible}
      style={style}
      visible={visible}
      overflowHeight={overflowHeight}
      marginTop={35}
      {...props}
    >
      <FocusWithin
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
      >
        <Box p={1} ref={divRef}>
          <BottomSheetHandle open={open} onClick={() => setOpen(o => !o)} />
          {children}
        </Box>
      </FocusWithin>
    </SwipeableBottomSheet>
  );
};
